import React, { useEffect, useState } from 'react';
import { getCookieConsent, saveCookieConsent } from '../../utils/cookieConsent';

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!getCookieConsent());
  }, []);

  if (!visible) return null;

  const accept = (analytics) => {
    saveCookieConsent({ analytics });
    setVisible(false);
  };

  return (
    <div
      className="fixed bottom-3 right-3 z-[20000] w-[min(20.5rem,calc(100vw-1.5rem))] sm:bottom-4 sm:right-4"
      role="dialog"
      aria-label="Cookie consent"
    >
      <div className="rounded-2xl border border-slate-200 bg-white/97 p-3.5 shadow-xl backdrop-blur-md sm:p-4">
        <p className="text-[10px] font-bold uppercase tracking-[0.12em] text-blue-600">Cookies</p>
        <p className="mt-1 text-sm font-bold text-slate-900">We use cookies</p>
        <p className="mt-1 text-xs leading-relaxed text-slate-600">
          Essential cookies keep you signed in. Analytics are optional.{' '}
          <a
            href="/legal/cookies.html"
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-blue-700 underline"
          >
            Policy
          </a>
        </p>
        <div className="mt-3 flex flex-col gap-1.5">
          <button
            type="button"
            onClick={() => accept(true)}
            className="w-full rounded-xl bg-blue-600 px-3 py-2 text-xs font-bold text-white hover:bg-blue-700"
          >
            Accept all
          </button>
          <button
            type="button"
            onClick={() => accept(false)}
            className="w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-xs font-bold text-slate-700 hover:bg-slate-50"
          >
            Essential only
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
